import { render, staticRenderFns } from "./LedgerTable.vue?vue&type=template&id=534fcd62"
import script from "./LedgerTable.vue?vue&type=script&lang=js"
export * from "./LedgerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports